/**
 *  The events for cornerstone streaming image volume
 *
 */
enum Events {
  ///////////////////////////////////////
  //            Loading Events
  ///////////////////////////////////////

  /**
   * Dynamic image volume time point index changed
   */
  DYNAMIC_VOLUME_TIME_POINT_INDEX_CHANGED = 'DYNAMIC_VOLUME_TIME_POINT_INDEX_CHANGED',
}

export default Events;
